import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotFoundComponent } from './not-found.component';
import { LayoutColumnModule } from '../../directives/layout-column/layout-column.module';
import { LayoutCenterModule } from '../../directives/layout-center/layout-center.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [NotFoundComponent],
    imports: [
        CommonModule,
        LayoutColumnModule,
        LayoutCenterModule,
        MatIconModule
    ],
    exports: [
        NotFoundComponent
    ]
})
export class NotFoundModule {
}
